// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37I9t","content":"styles_content__3knq8"};